/**
 * @summary An edit model used to house original and modified values of an object
 * @description This can only function on simple objects that can be easily deep copied.
 *              Computed fields and functions are lost. Use CloneableEditModel if you need to maintain functions.
 */
export class EditModel<T> {
    // These are for external state management
    public editing: boolean = false;
    public modified: boolean = false;
    public deleted: boolean = false;
    public new: boolean;

    /** The original item, this will never change. */
    public original: T;

    /** The temporary working value, this is what should be edited directly. */
    public temp: T;

    /** The committed, modified value. This is what should be referenced for display. */
    public value: T;

    /** The previous value before the last value was committed. Essentially a history value. */
    public previousValue: T;

    constructor(original: T, isNew = false) {
        this.original = original;
        this.new = isNew;
        this.value = JSON.parse(JSON.stringify(original));
        this.temp = JSON.parse(JSON.stringify(original));
        this.previousValue = JSON.parse(JSON.stringify(original));
    }

    /** Commits the current value to the previousValue field and the temp value to the value field */
    public commit() {
        this.previousValue = JSON.parse(JSON.stringify(this.value));
        this.value = JSON.parse(JSON.stringify(this.temp));
    }

    /** Reset the temp variable to the current value, such as after cancelling an edit */
    public resetTemp() {
        this.temp = JSON.parse(JSON.stringify(this.value));
    }

    /** Restores the previously set value to previousValue, such as when a commit has to be reverted */
    public restorePreviousValue() {
        if (JSON.stringify(this.previousValue) === JSON.stringify(this.original)) {
            this.modified = false;
        }
        this.value = JSON.parse(JSON.stringify(this.previousValue));
    }

    /** Restores the entire object back to it's original value */
    public restore() {
        this.value = JSON.parse(JSON.stringify(this.original));
        this.previousValue = JSON.parse(JSON.stringify(this.original));
        this.temp = JSON.parse(JSON.stringify(this.original));
        this.modified = false;
    }
}
